// extracted by mini-css-extract-plugin
export default {"container":"AboutUsFAQ_container__99tXU","dropdownSection":"AboutUsFAQ_dropdownSection__5LrU-"};